module.exports = __webpack_public_path__ + "img/goldkette_gruen.64b7ceb8.png";